'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { LeverageBadge, OrderSideBadge } from '@flipster/features/src/misc/badge';
import { SymbolDisplay } from '@flipster/features/src/misc/display';
import { OpenPosition } from '@flipster/r230522/original/position';
import { getPositionDisplayPrice } from '@flipster/r230522/original/ticker-price';
import Formatted from '@flipster/react/design-utils/formatted';
import { PageType } from '@flipster/utils/segment/events/position';

import InputForm from './InputForm';
import styles from './adjustMarginModal.module.scss';
import { adjustMarginStateBunja } from './state';

interface Props {
  currentPosition: OpenPosition;
  page: PageType;
}

const AdjustMarginContent = ({ currentPosition, page }: Props) => {
  const { instrumentAtom } = useBunja(adjustMarginStateBunja);
  const instrument = useAtomValue(instrumentAtom);

  const { side, symbol, initLeverage, marginType } = currentPosition;
  const displayPrice = getPositionDisplayPrice(currentPosition);

  return (
    <section className={styles.adjustMarginContent}>
      <div className={styles.symbolInfo}>
        <SymbolDisplay
          css={{ flex: 1 }}
          symbol={symbol}
          icon={<SymbolDisplay.Icon size={32} space={8} />}
          mainLabel={<SymbolDisplay.Label value='shortName' css={{ textStyle: 'Text/L/Strong' }} />}
          subLabel={
            <Formatted.Number
              method='round-half-up'
              value={displayPrice}
              precision={instrument.pricePrecision}
              toFixed
              css={{ textStyle: 'Legacy/Number3' }}
            />
          }
        />
        <OrderSideBadge orderSide={side} />
        <LeverageBadge leverage={initLeverage} marginType={marginType} />
      </div>
      <InputForm currentPosition={currentPosition} page={page} />
    </section>
  );
};

export default AdjustMarginContent;
